import { Component } from '@angular/core';

@Component({
  selector: 'app-no-analytics-message',
  templateUrl: './no-analytics-message.component.html',
  styleUrls: ['./no-analytics-message.component.css']
})
export class NoAnalyticsMessageComponent {
}
